import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'clicks',
        label: t('search.keyword.chart.avgClicks'),
        icon: 'clicks',
        yAxisID: 'y3',
    },
    {
        key: 'impressions',
        label: t('search.keyword.chart.avgImpressions'),
        icon: 'search',
        yAxisID: 'y',
    },
    {
        key: 'position',
        label: t('search.keyword.chart.avgPosition'),
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
    {
        key: 'ctr',
        label: t('search.keyword.chart.avgCTR'),
        format: '0.00%',
        render: (data) => numeral(data).format('0.00%'), // data assumed 0-1
        icon: 'ctr',
        yAxisID: 'y1',
    },
    {
        key: 'urls',
        label: t('search.keyword.chart.avgPages'),
        icon: 'pagev-view',
        yAxisID: 'y4',
    },
];

export default keys;
